import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { AuthService } from '@core/auth.service';
import { AuthPathsService } from '@core/multi-tenant-auth/auth-paths.service';

export const ensureStudentPortalGuard: CanMatchFn = () => {
  const authService = inject(AuthService);
  const authPaths = inject(AuthPathsService);

  // Never match Student Portal routes when on the auth hub origin.
  if (authPaths.isCurrentOriginAuthHub()) {
    return false;
  }

  return authService.getCurrentPortalType() === 'student';
};
